module.exports = __webpack_public_path__ + "static/img/图层 538.103a9d06.png";